import React from "react";
import { Navigate, Route } from "react-router-dom";
import * as T from "../utilities/frontendTypes";
import QueryBoundary from "../Components/QueryBoundary";

const FirmProfile = React.lazy(() => import("../Pages/ServiceProviderPages/FirmProfile"));
const Practitioners = React.lazy(() => import("../Pages/ServiceProviderPages/Practitioners"));
const SowDetailsConsole = React.lazy(() => import("../Pages/ServiceProviderPages/sowDetails"));
const Invoices = React.lazy(() => import("../Pages/ServiceProviderPages/Invoices"));
const CreateInvoice = React.lazy(() => import("../Pages/LandingPage/components/CreateInvoice"));
const SpInvoiceDetails = React.lazy(() => import("../Pages/ServiceProviderPages/SpInvoiceDetails"));

const LazyRoute = QueryBoundary;

interface ProviderRoutesProps {
  roleCheck: (roles: T.UserRole[], element: JSX.Element) => JSX.Element;
}

export function providerRoutes({
  roleCheck
}: ProviderRoutesProps) {
  return (
    <>
      <Route path="firm-profile" element={roleCheck(["serviceProvider"], <LazyRoute><FirmProfile /></LazyRoute>)} />
      <Route path="practitioners" element={roleCheck(["serviceProvider"], <LazyRoute><Practitioners /></LazyRoute>)} />
      <Route path="statement-of-work" element={<Navigate to="/dashboard" replace />} />
      <Route path="statement-of-work/:sowId" element={roleCheck(["serviceProvider", "superAdmin"], <LazyRoute><SowDetailsConsole /></LazyRoute>)} />
      <Route path="invoices" element={roleCheck(["serviceProvider", "superAdmin"], <LazyRoute><Invoices /></LazyRoute>)}>
        <Route path=":sowId" element={<LazyRoute><CreateInvoice /></LazyRoute>} />
      </Route>
      <Route path="invoice/:invoiceId" element={roleCheck(["serviceProvider", "superAdmin"], <LazyRoute><SpInvoiceDetails /></LazyRoute>)} />
    </>
  );
}
